export default "/ARB+ETH-icon.f968655950aad7b3ce48bf87e1f8e23c.png";